
  import { ref, watch } from 'vue';
  import useClickOutside from '../composables/useClickOutside';
  
  const props = {
    show: {
      type: Boolean,
      default: false,
    },
  };
  
  const components = {
    
  };
  
  export default {
    name: 'ModalDialog',
    props,
    components,
    setup(props: any, context: any) {
      const showModal = ref(false);
      const modal = ref(null);
      const { onClickOutside } = useClickOutside();
  
      function closeModal() {
        context.emit('close');
      }
  
      onClickOutside(modal, () => {
        if (showModal.value === true) {
          closeModal();
        }
      });
  
      watch(
        () => props.show,
        show => {
          showModal.value = show;
        },
      );
  
      return {
        closeModal,
        showModal,
        modal,
      };
    },
  };
  